import React, { useCallback, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { Card, CardBody, Col, Row } from "reactstrap"
import totalOrdersImg from "assets/images/cards/dashboard/totalOrders.png"
import earningsImg from "assets/images/cards/dashboard/earnings.png"
import lowStockAlertImg from "assets/images/cards/dashboard/lowStockAlert.png"
import pendingOrdersImg from "assets/images/cards/dashboard/pendingOrders.png"
import revenueImg from "assets/images/cards/dashboard/revenue.png"
import { useNavigate } from "react-router-dom"
import { CurrentTapType as OrderCurrentTapType } from "pages/admin/Orders/ordersType"

export const OverviewCards = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const cardsData: {
    title: string
    values: [number, number]
    icon: string
  }[] = useMemo(() => {
    return [
      {
        title: t("dashboard_bundlesTotalOrders"),
        values: [100, 200],
        icon: totalOrdersImg,
      },
      {
        title: t("dashboard_totalActiveVendor"),
        values: [100, 200],
        icon: pendingOrdersImg,
      },
      {
        title: t("dashboard_totalActiveCustomers"),
        values: [100, 200],
        icon: revenueImg,
      },
      {
        title: t("dashboard_disputesOrders"),
        values: [100, 200],
        icon: earningsImg,
      },
      {
        title: t("dashboard_commissionsRevenue"),
        values: [21250, 222250],
        icon: lowStockAlertImg,
      },
    ]
  }, [t])

  // const cardClickHandler = useCallback(
  //   (index: number) => {
  //     switch (index) {
  //       case 0:
  //         navigate("/orders?tab=" + OrderCurrentTapType.all)
  //         break
  //       case 1:
  //         navigate("/orders?tab=" + OrderCurrentTapType.pending)
  //         break
  //       case 2:
  //       case 3:
  //         navigate("/revenue")
  //         break
  //       case 4:
  //         navigate("/products?lowStockAlert=" + cardsData[index].total)
  //         break
  //       default:
  //         break
  //     }
  //   },
  //   [navigate]
  // )

  return (
    <Row style={{ marginBottom: "-1.5rem" }}>
      {cardsData.map((report, key) => (
        <Col
          md="4"
          lg="2.4"
          key={"_col_" + key}
          className="col-lg-5ths"
          style={{ height: "fit-content" }}
        >
          <Card
            className="mini-stats-wid shadow-sm rounded-3"
            style={{ cursor: "pointer", border: "none" }}
            // onClick={() => cardClickHandler(key)}
          >
            <CardBody>
              <div className="d-flex justify-content-between align-items-start">
                <div className="d-flex flex-column gap-2 flex-grow-1">
                  <p
                    className="text-muted fw-medium mb-0"
                    style={{ color: "#878A99", fontSize: "13px" }}
                  >
                    {report.title}
                  </p>
                  <h4 className="mb-0 fw-semibold" style={{ fontSize: "20px" }}>
                    {report.values[0].toLocaleString()} <span className="text-muted fw-medium" style={{ fontSize: "16px" }}>/ {report.values[1].toLocaleString()}</span>
                  </h4>
                  <p className="mb-0 font-size-13">
                    <span className="text-success fw-medium">12%</span> <span className="text-muted">{t("dashboard_fromPreviousPeriod")}</span>
                  </p>
                </div>
                <div className="flex-shrink-0">
                  <img 
                    src={report.icon} 
                    alt={report.title}
                    style={{ width: "48px", height: "48px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  )
}
